import React, { useState, useEffect, KeyboardEvent } from 'react';
import styled from 'styled-components';
import ISlideEvent, { SlideEventType } from 'interfaces/ISlideEvent';
import { DateTime } from 'luxon';
import DraggableVideo from 'components/DraggableVideo';
import useStream from 'hooks/useStream';


const SlideFrame = styled.div`
  width:100%;
  height:100%;
  /* flex:1; */
  &:focus {
    outline:none;
  }
  .frame {
    width:100%;
    height:100%;
    overflow-x:hidden;
    .container {
      width:auto;
      height:100%;
      white-space:nowrap;
      transition:transform ease .5s;
      transform: ${(props) => `translate(${(props as any)['data-slide'] * -100}%, 0)`};
      .slide {
        width:100%;
        height:100%;
        display:inline-flex;
        justify-content:center;
        align-items:center;
        &.slide-1 {
          background-color:#ff0;
        }
        &.slide-2 {
          background-color:#f00;
        }
      }
    }
  }
  .frame-thumb {
    position:fixed;
    bottom:-10em;
    width:100%;
    height:5em;
    white-space:nowrap;
    overflow-x:auto;
    border-top: 1px solid #333;
    padding: 1em 2em;
    transition: bottom .4s ease;
    &.visible {
      bottom:0;
    }
    .slide-thumb {
      display:inline-flex;
      width:5em;
      height:5em;
      justify-content:center;
      align-items: center;
      margin: 0 1em;
      border:2px solid;
      cursor:pointer;
      &:hover {
        box-shadow: 0 0 0 4px #333;
      }
      &.selected {
        box-shadow: 0 0 0 6px #333;
      }
    }
  }
  .frame-debug {
    position:fixed;
    width:15em;
    /* height:calc(100%-4em); */
    height:80%;
    top:2em;
    right: -20em;
    background:#fff;
    overflow-y:auto;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.25);
    transition: right .4s ease;
    font-size:0.8rem;
    &.visible {
      right:2em;
    }
  }
`;

const Frame = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  align-items:stretch;
  width:100%;
  height:100%;
  .frame-menu {
    height:3em;
  }
  ${SlideFrame}: {
    flex:1;
  }
`;

let baseTime:DateTime = DateTime.local();
let mediaRecorder:MediaRecorder|null = null;


const recordOption = {mimeType: 'video/webm;codecs=vp9'};
// const recordOption = {mimType: 'video/mp4'}; //TODO
// let recordedBlob:Blob[] = [];

const SlideTest = () => {
  const slides = [...new Array(20)].map((v,idx) => idx);
  const [slideIdx, setSlideIdx] = useState<number>(0);
  const [history, setHistory] = useState<ISlideEvent[]>([]);
  const [historyVisible, setHistoryVisible] = useState<boolean>(true);
  const [thumbVisible, setThumbVisible] = useState<boolean>(true);
  const [recording, setRecording] = useState<boolean>(false);
  const [blobs, setBlobs] = useState<Blob[]>([]);

  const stream = useStream();
  const recordStart = () => {
    if(stream) {
      if(mediaRecorder) {
        mediaRecorder.resume();
      } else {
        mediaRecorder = new MediaRecorder(stream, recordOption);
        mediaRecorder.ondataavailable = (e:BlobEvent) => {
          if(e.data.size > 0)
            setBlobs([...blobs,e.data]);
            console.log('pushed;');
            // recordedBlob.push(e.data);
        }
        mediaRecorder.start();
      }
    }
  }
  const recordPause = () => {
    if(mediaRecorder) {
      mediaRecorder.pause();
    }
  }
  const recordStop = () => {
    if(mediaRecorder && recording) {
      mediaRecorder.stop();
    }
  }

  const download = () => {
    let blob = new Blob(blobs, {
      type: "video/webm"
    });
    let url = URL.createObjectURL(blob);
    let a = document.createElement("a");
    document.body.appendChild(a);
    (a as any).style = "display: none";
    (a as any).href = url;
    (a as any).download = "test.webm";
    a.click();
    window.URL.revokeObjectURL(url);
  }
  

  const addHistory = (idx:number) => {
    const timeStamp = Math.abs(baseTime.diffNow('milliseconds').milliseconds);
    setHistory([
      ...history,
      {
        slideEventType: SlideEventType.NEXT,
        indexTime:timeStamp,
        slideIndex:idx
      }
    ]);
    setSlideIdx(idx);
  }
  useEffect(() => {
    baseTime = DateTime.local();
  }, [])

  return(
    <Frame>
      <div className='menu'>
        <button
          onClick={()=>setHistoryVisible(!historyVisible)}
        >
          히스토리 {historyVisible? '끄기':'켜기'}
        </button>
        <button
          onClick={()=>setThumbVisible(!thumbVisible)}
        >
          썸네일 {thumbVisible? '끄기':'켜기'}
        </button>
        <button onClick={()=>{
          if(recording)
            recordPause();
          else
            recordStart();
          setRecording(!recording);
          }}
        >
          {recording? '일시정지':'시작'}
        </button>
        <button onClick={()=>{
          recordStop();
          setRecording(!recording);
          }}
        >
          정지
        </button>
        {
          blobs.length > 0 &&
          <button onClick={()=>download()}>
            다운로드
          </button>
        }
      </div>
      <SlideFrame
        data-slide={slideIdx}
        tabIndex={0}
        onKeyUp={(e:KeyboardEvent<HTMLElement>)=>{
          switch(e.key) {
            case 'ArrowLeft':
              addHistory(slideIdx-1);
              break;
            case 'ArrowRight':
              addHistory(slideIdx+1);
              break;
          }
        }}
      >
        <div className='frame'>
          <div className='container'>
            {
              slides.map(idx => (
                <div key={`slide-${idx}`} className='slide slide-1'>slide #{idx}</div>
              ))
            }
          </div>
        </div>
        <div className={`frame-thumb ${thumbVisible && 'visible'}`}>
          {
            slides.map(idx => (
              <div
                key={`slide-thumb-${idx}`}
                className={`slide-thumb ${idx === slideIdx && 'selected'}`}
                onClick={()=>addHistory(idx)}
              >
                slide #{idx}
              </div>
            ))
          }
        </div>
        <div className={`frame-debug ${historyVisible && 'visible'}`}>
          <ol>
            {
              history.map((row, idx)=> (
                <li key={`li-history-${idx}`}>
                  [{row.indexTime}ms]: slide#{row.slideIndex}
                </li>
              ))
            }
          </ol>
        </div>
      </SlideFrame>
      <DraggableVideo/>
    </Frame>
  )
}

export default SlideTest;